<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Unit', apiMethod: 'Units', form: () => import('../forms/UnitForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                ],
                tabs: [
                    { text: 'Tests', value: 'unitId', table: () => import('../tables/TestsTable') },
                ],
                mainForm: () => import('../forms/UnitForm'),
                claimName: 'Units',
                apiMethod: 'Units',
            }
        }
    };
</script>
